import React from "react";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Form from "../layout/form.jsx";
import Loader from "../layout/loader.jsx";
import { toast } from "react-toastify";
import API from "../../services/api.jsx";
import Helpers from "../../services/helpers.jsx";

class AffiliateEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      breadcrumb: { title: "back to Affiliate list", path: "/affiliates" },
      fields: {
        name: { label: "Name", type: "text", required: true },
      },
      affiliate: {
        name: null,
      },
    };
    this.saveEntity = this.saveEntity.bind(this);
  }

  componentDidMount() {
    API.getAffiliate(this.props.match.params.affiliateId).then((affiliate) => {
      this.setState({
        loading: false,
        affiliate: affiliate,
      });
    });
  }

  saveEntity(fields) {
    this.setState({ loading: true });
    fields.assets = [];
    API.update("affiliates", this.props.match.params.affiliateId, fields)
      .then(() => {
        toast.success("Affiliate has been created");
        this.props.history.push("/affiliates");
      })
      .catch(() => {
        // toast.error("An unexpected error has occurred, please try again");
        this.setState({ loading: false });
      });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Head title={'Edit affiliate'} breadcrumb={this.state.breadcrumb} />
          <Content>
            <Form
              fields={this.state.fields}
              cancel={() => this.props.history.push('/affiliates')}
              save={this.saveEntity}
              entity={this.state.affiliate}
              hideCancel={!Helpers.checkPermissions('affiliates:edit')}
              hideSave={!Helpers.checkPermissions('affiliates:edit')}
              disabled={!Helpers.checkPermissions('affiliates:edit')}
            />
          </Content>
        </>
      );
  }
}

export default AffiliateEdit;
